module.exports = __webpack_public_path__ + "img/personal_presentation.3c9573c3.jpg";